import { ApiRequest as ApiRequestFallback, WithCache } from "./base.fallback";

const ApiRequest = ApiRequestFallback;

export { ApiRequest, WithCache };
